// SUNDAY BATCH D-7 — the ONE way a number pair / triple ("tested / selected", "signed / total", "amount / PM",
// "total / resolved / unresolved") is written on screen: an LTR isolate, so Arabic reads the figures in the same order as
// English (a bare "3 / 9" inside right-to-left text is reordered to "9 / 3"). `parts` are already formatted strings.
import React from "react";

export default function NumPair({ parts, sep = " / ", testid, className }) {
  const list = Array.isArray(parts) ? parts : [];
  return <bdi dir="ltr" data-testid={testid} className={className}>{list.join(sep)}</bdi>;
}
